module.exports = __webpack_public_path__ + "img/2-3.30d6b848.png";